// extracted by mini-css-extract-plugin
export var cardLayout = "_6o-1";
export var paginationContainer = "_6o-0";